import * as z from "zod";
import { parametersSchema } from "../fields/Parameters/schemas";
import { issueAtSchema } from "./IssueAt.schema";
import { revokeAtSchema } from "./RevokeAt.schema";

export const CreateValidatedQuestionFormSchema = z
    .object({
        issueAt: issueAtSchema,
        revokeAt: revokeAtSchema,
        subjectDids: z.array(z.string().or(z.number())).min(1, {
            message: "validated-question-create.subject.errors.required",
        }),
        indicators: z
            .array(
                z.object({
                    name: z.string(),
                    path: z.string(),
                    parameters: parametersSchema.optional(),
                })
            )
            .min(1, {
                message: "validated-question-create.indicators.errors.required",
            }),
    })
    .refine(
        (data) => {
            if (!data.revokeAt) {
                return true;
            }

            return new Date(data.revokeAt) > new Date(data.issueAt);
        },
        {
            message:
                "validated-question-create.date.errors.revoke-at-before-issue-at",
            path: ["revokeAt"],
        }
    );
